import { LocalizedString } from '@synergy/models';

export const nullIfEmptyLocalizedString = (object?: LocalizedString | null): LocalizedString | null => {
    if (!object) {
        return null;
    }
    if (Object.keys(object).length === 0) {
        return null;
    }
    if (Object.values(object).every(value => value === '')) {
        return null;
    }

    return object;
};
